import { useExerciseImprovementActionsStore } from '../../store/exercise-improvement-actions.store.js';
import { BcmSourcedImprovementActionsIntegration } from './bcm-sourced-improvement-actions.integration.js';

export class ExerciseImprovementActionsIntegration extends BcmSourcedImprovementActionsIntegration {
    constructor(actionService) {
        super(actionService, {
            sourceType: 'exercise',
            store: () => useExerciseImprovementActionsStore.getState(),
            messagesNs: 'bcmExercise',
        });
    }
}
